import React from 'react';
import LoginV5 from './login_v5/login';
import LoginHLB from './login_hlb/login';
import { Utils } from "@/tools/utils";


export const Login = () => {
    return Utils.isHLB()?
        <LoginHLB/>
        :
        <LoginV5/>;
};


export default Login;
